
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/columns",
      function () {
        return require("private-next-pages/columns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/columns"])
      });
    }
  